import PropTypes from 'prop-types';
import LinkButton from '@/components/common/LinkButton';
import MillesimaLink from '@/components/common/MillesimaLink';
import { BREAKPOINTS_LABELS } from '@/constants/gui';
import { CtaPropTypes } from '@/constants/propTypes';
import styles from './ImageInfoCard.module.scss';

export const ImageInfoCard = ({ data, breakpoint, lazy = false }) => {
	const { img, color, contentTitle, desc, cta, alt } = data;

	return (
		<div
			className={`${styles.container}${breakpoint ? ' ' + styles[breakpoint] : ''}`}
			data-test-id="image-info-card"
			style={{ backgroundColor: color }}
		>
			<div className={styles.image} data-test-id="image-info-card-img">
				<MillesimaLink href={cta.url} ariaLabel={contentTitle} isWithoutContainer>
					<img src={img} alt={alt} loading={lazy ? 'lazy' : 'eager'} />
				</MillesimaLink>
			</div>
			<div className={styles.text} data-test-id="image-info-card-text">
				<MillesimaLink href={cta.url} ariaLabel={contentTitle} isWithoutContainer>
					<h2 className={styles.title} data-test-id="image-info-card-text-title">
						{contentTitle}
					</h2>
				</MillesimaLink>
				<div className={styles.desc} data-test-id="image-info-card-text-desc" dangerouslySetInnerHTML={{ __html: desc }} />
				<div className={styles.link} data-test-id="image-info-card-text-link">
					<LinkButton cta={cta} isNofollow />
				</div>
			</div>
		</div>
	);
};

ImageInfoCard.propTypes = {
	data: PropTypes.shape({
		img: PropTypes.string,
		color: PropTypes.string,
		contentTitle: PropTypes.string,
		desc: PropTypes.string,
		cta: PropTypes.shape(CtaPropTypes).isRequired,
		alt: PropTypes.string,
	}),
	breakpoint: PropTypes.oneOf(BREAKPOINTS_LABELS),
	lazy: PropTypes.bool,
};

export default ImageInfoCard;
